<section class="client-management">
    <div class="row">
        <div class="col-md-12">
            <app-breadcrumb [routePath2]="'/customer-order'" [title2]="'ORDERMANAGEMENT.MANAGE_ORDER'" [title3]="title"
                [type]="'ORDERMANAGEMENT.CreateOrderMenu'">
            </app-breadcrumb>
        </div>
        <div class="col-md-12">
            <div class="table-content box-style">
                <div class="table-heading">
                    <h3 style="font-weight: 600">
                        <span>
                            {{ title | translate }}
                            {{ "ORDERMANAGEMENT.CreateOrderMenu" | translate }}</span>
                    </h3>
                    <div class="search-form-wrapper">
                        <div class="buttons-group">
                            <p>
                                <span style="color: #ea5455">*</span>
                                {{
                                "GENERAL.Indicates a required field"
                                | translate
                                }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="form-content-box">
                    <form [formGroup]="orderForm" (ngSubmit)="addUpdateOrder()" class="w-100" name="orderForm"
                        novalidate>
                        <div class="row">
                            <div class="col-xl-6 ">
                                <div class="form-field">
                                    <mat-form-field appearance="outline" class="element-full-width">
                                        <mat-label>{{
                                            "ORDERMANAGEMENT.OrderId"
                                            | translate
                                            }}</mat-label>
                                        <input readonly placeholder="system generated number" readonly
                                            [attr.disabled]="true" (keydown)="space($event)" disabled
                                            formControlName="proposalId" matInput name="orderId" type="text" />
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                         <div class="row">
                            <div class="col-xl-6 ">
                                <mat-form-field appearance="outline" class="element-full-width">
                                    <mat-label>{{  "ExecuteOrder.ManageProposal.subject"  | translate }}
                                        <span style="color: #ea5455">*</span></mat-label>
                                    <input (keydown)="space($event)" formControlName="orderName" matInput
                                        name="orderName" type="text" />
                                    <mat-error *ngIf=" orderForm.controls.orderName
                                                .errors?.required ">
                                        {{"ExecuteOrder.ManageProposal.subjectRequired" | translate }}
                                    </mat-error>
                                </mat-form-field>
                            </div>
                                      <div class="col-xl-6 ">
                                <div class="form-field">
                                    <mat-form-field appearance="outline" class="element-full-width">
                                        <mat-label>{{'ExecuteOrder.ManageProposal.SellingCatalog' |
                                            translate}}</mat-label>
                                        <mat-select formControlName="sellingCatalogId">
                                            <mat-option>
                                                <ngx-mat-select-search [formControl]="sellingCatalogSearchControl"
                                                    noEntriesFoundLabel="{{'TABLE.No_record_found' | translate}}"
                                                    placeholderLabel="{{'Search' | translate}}"></ngx-mat-select-search>
                                            </mat-option>
                                            <!-- <mat-select-filter #resetSearch [array]="sellingData"
                                                (filteredReturn)="sellingCatalogData = $event"
                                                placeholder="{{'Search' | translate}}"
                                                [displayMember]="'sellingCatalogName'"></mat-select-filter> -->
                                            <mat-option *ngFor="let obj of sellingCatalogData | filterBy: ['sellingCatalogName']: sellingCatalogSearchControl.value"
                                                [value]="obj.sellingCatalogId">
                                                {{ obj.sellingCatalogName || '-' }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>

                                </div>
                            </div>
                        </div>
                        <div class="row">
                             <div class="col-xl-6">
                                <div class="form-field">
                                    <mat-form-field appearance="outline" class="element-full-width">
                                        <mat-label>{{'ORDERMANAGEMENT.MANAGECUSTOMER.ITEM_SELECTION_OPTIONS' |
                                            translate}}</mat-label>
                                        <mat-select formControlName="sellingCatalogItemIds" multiple>
                                            <mat-option>
                                                <ngx-mat-select-search [formControl]="sellingCatalogItemSearchControl"
                                                    noEntriesFoundLabel="{{'TABLE.No_record_found' | translate}}"
                                                    placeholderLabel="{{'Search' | translate}}"></ngx-mat-select-search>
                                            </mat-option>
                                            <!-- <mat-select-filter #resetSearch [array]="sellingCatalogFilter"
                                                (filteredReturn)="sellingCatalogItems = $event"
                                                placeholder="{{'Search' | translate}}"
                                                [displayMember]="'sellingCatalogItemName'">
                                            </mat-select-filter> -->
                                            <mat-option *ngFor="let obj of sellingCatalogItems | filterBy: ['sellingCatalogItemName']: sellingCatalogItemSearchControl.value" [value]="obj._id">
                                                {{obj.sellingCatalogDetails.unitName || obj.sellingCatalogDetails.taskName || obj.sellingCatalogDetails.macroTaskName}}
                                                ({{obj.customerPrice | customCurrency}})
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="col-xl-6 ">
                                <mat-form-field appearance="outline" class="currency element-full-width">
                                    <mat-label>{{
                                        "ExecuteOrder.ManageProposal.budget"
                                        | translate
                                        }}</mat-label>
                                    <input (keypress)="numberOnly($event)" formControlName="budget" matInput
                                        name="budget" type="numer" />
                                    <span style="color:rgb(168, 168, 168)">EURO</span>
                                </mat-form-field>
                            </div>  
                        </div>
                        <div class="row">
                            <div class="col-xl-6 ">
                                <mat-form-field appearance="outline" class="element-full-width date-select">
                                    <mat-label>{{"ExecuteOrder.ManageProposal.deadline" | translate}}
                                        <span style="color: #ea5455">*</span></mat-label>
                                    <input formControlName="completionTime" [min]="today" matInput
                                        [matDatepicker]="dp3">
                                    <mat-datepicker-toggle matIconSuffix [for]="dp3"
                                        class="full-date-select"></mat-datepicker-toggle>
                                    <mat-datepicker #dp3></mat-datepicker>
                                    <mat-error *ngIf="
                                    orderForm.controls.completionTime
                                        .errors?.required">
                                        {{
                                        "ExecuteOrder.ManageProposal.deadlineRequired"
                                        | translate
                                        }}
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col-xl-6 ">
                                <mat-form-field appearance="outline" class="element-full-width">
                                    <mat-label>{{
                                        "ORDERMANAGEMENT.PaymentTerms"
                                        | translate
                                        }}</mat-label>
                                    <mat-select formControlName="paymentTermsId" multiple>
                                        <mat-select-filter #resetSearch [array]="paymentTermsList"
                                            (filteredReturn)="paymentFilterList = $event"
                                            placeholder="{{'Search' | translate}}"
                                            [displayMember]="'paymentTermsName'"></mat-select-filter>
                                        <mat-option *ngFor="let scope of paymentFilterList" [value]="scope._id">
                                            {{ scope.paymentTermsName || '-' }}
                                        </mat-option>
                                    </mat-select>

                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xl-12">
                                <mat-form-field appearance="outline" class="element-full-width">
                                    <mat-label>{{
                                        "ExecuteOrder.ManageProposal.executiveSummary"
                                        | translate
                                        }}<span style="color: #ea5455">*</span> </mat-label>
                                    <textarea maxlength="1000" matInput formControlName="description"
                                        name="description"></textarea>
                                    <mat-error *ngIf="
                                    orderForm.controls.description.errors?.required ">
                                         {{ "ExecuteOrder.ManageProposal.executiveSummaryRequired"| translate}}
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        
                        </div>
                        <div class="row">
                             <div class="col-xl-12">
                                <mat-form-field appearance="outline" class="element-full-width">
                                    <mat-label>{{
                                        "ORDERMANAGEMENT.TaskActivities"
                                        | translate
                                        }}</mat-label>
                                    <textarea maxlength="1000" matInput formControlName="taskOrActivties"
                                        name="taskOrActivties"></textarea>
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="col-xl-12 col-xxl-12">
                            <label>{{'ExecuteOrder.ManageProposal.UploadFile' | translate}}</label><span class="text-danger" style="margin-left: 4px;">(Max {{maxFileSizeMB}}MB)</span>
                            <div class="generate-button">
                                <button class="btn-style red-btn file-upload-button" type="button">
                                    <span class="material-icons">upload</span>
                                    {{ 'EDIT COMPANY.Drag and Drop here' | translate }} <br>
                                    {{ 'EDIT COMPANY.Or' | translate }} <br>
                                    <span class="blue-label">{{ 'EDIT COMPANY.Browse File' | translate }}</span>
                                    <input type="file" id="file2"
                                        accept=".jpeg,.jpg,.png,.pdf,.pjp,.pjpeg,.jfif,.mp3,.m4v,.mp4" #documentInput
                                        multiple (change)="onFilesChanged(documentInput)" />
                                </button>

                                <span class="d-flex flex-column">
                                    <ng-container *ngFor="let file of documentInputs">
                                        <div class="d-flex align-items-center">
                                            {{ file.name ? file.name : file.file }} ({{ formatBytes(file.size) }})
                                            <span class="material-icons close-icon"
                                                (click)="removeFile(file)">close</span>
                                            <br>
                                            <span *ngIf="file.id" title="Download image file" class="download"
                                                (click)="downloadImageFile(file.id, file.name ? file.name : file.file)"><mat-icon>cloud_download</mat-icon></span>
                                        </div>
                                    </ng-container>

                                </span>
                            </div>

                        </div>

                        <div class="form-footer step-form-bottom">

                            <button class="btn-style red-line-btn" routerLink="/customer-order" type="button">
                                {{ "GENERAL.Cancel" | translate }}
                            </button>

                            <button class="btn-style theme-btn" type="submit">
                                {{ "GENERAL.Save" | translate }}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</section>